// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Digiworld Universe - Aliens Configuration
 * 
 * IMPORTANT: This file only contains the planet-to-alien mapping.
 * All alien definitions are in src/config/AlienSpeciesConfig.js
 * 
 * Workflow:
 * 1. Add alien to AlienSpeciesConfig.js first
 * 2. Then map it to planets here
 */

export const DigiworldAliensPlanets = {
  planets: {
    // File Island (1600) - Starting area with Rookie Digimon
    1600: ['agumon', 'gabumon', 'tentomon'],
    
    // Server Continent (1601) - Main hub with friendly Rookies
    1601: ['agumon', 'gabumon'],
    
    // Folder Continent (1602) - Fire-type territory
    1602: ['agumon', 'greymon'],
    
    // Network City (1603) - Ice-type territory
    1603: ['gabumon', 'garurumon'],
    
    // Dark Area (1604) - Insect-type territory
    1604: ['tentomon', 'kabuterimon'],
    
    // Kernel Sphere (1605) - Dragon evolution line
    1605: ['greymon', 'metalgreymon', 'devimon'],
    
    // Firewall Fortress (1606) - Wolf evolution line
    1606: ['garurumon', 'weregarurumon', 'devimon'],
    
    // Data Stream Nexus (1607) - Knowledge-based area
    1607: ['kabuterimon', 'megakabuterimon', 'devimon'],
    
    // Recycle Bin (1608) - Mega level stronghold
    1608: ['metalgreymon', 'wargreymon', 'metalgarurumon', 'devimon'],
    
    // Cloud Storage (1609) - Ultimate challenge area
    1609: ['weregarurumon', 'megakabuterimon', 'wargreymon', 'metalgarurumon'],
    
    // Digital Singularity (1699) - The source code of reality
    1699: ['wargreymon', 'metalgarurumon', 'devimon']
  },
  
  // Random encounter Digimon (for space travel events)
  randomEncounters: [
    'agumon',
    'gabumon',
    'tentomon',
    'greymon'
  ],
  
  // Hostile species that may attack on sight
  hostileSpecies: [
    'devimon'
  ],
  
  // Friendly traders willing to do business
  friendlyTraders: [
    'agumon',
    'gabumon',
    'tentomon',
    'wargreymon',
    'metalgarurumon'
  ]
};

export default DigiworldAliensPlanets;
